<script>
	// import Vue from 'vue'
	import Store from "./store"
	import permission from './utils/permission.js'
	import {
		uploadImg,
	} from "./utils/api.js"
	import { wgs84_to_gcj02 } from "./utils/gps_to_gcj02.js"
	import { debounceEvent } from "@/utils/index.js"
	// import locationWatcher from "./utils/locationWatcher.js"
	export default {
		onLaunch: function(options) {
			console.log("app onLaunch options: ", options)
			uni.getSystemInfo({
				success: function(e) {
					// #ifndef MP
					// Vue.prototype.StatusBar = e.statusBarHeight;
					// if (e.platform == 'android') {
					// 	Vue.prototype.CustomBar = e.statusBarHeight + 50;
					// } else {
					// 	Vue.prototype.CustomBar = e.statusBarHeight + 45;
					// };
					// // #endif

					// // #ifdef MP-WEIXIN
					// Vue.prototype.StatusBar = e.statusBarHeight;
					// let custom = wx.getMenuButtonBoundingClientRect();
					// Vue.prototype.Custom = custom;
					// Vue.prototype.CustomBar = custom.bottom + custom.top - e.statusBarHeight;
					// // #endif		

					// // #ifdef MP-ALIPAY
					// Vue.prototype.StatusBar = e.statusBarHeight;
					// Vue.prototype.CustomBar = e.statusBarHeight + e.titleBarHeight;
					// // #endif
				}
			})
		
			if (!Store.state.userInfo?.id || Store.state.userInfo?.status == 0) {
				// #ifdef APP
				uni.navigateTo({
					url: "/pages/login/login"
				})
				// #endif
				// #ifdef H5
				if (!window.location.href.match('/pages/my/map')) {
					uni.navigateTo({
						url: "/pages/login/login"
					})
				}
				// #endif
			}
		},
		globalData: {
			uploadImg,
			address: null,
			             // (0已取消,  1待支付,   2待接单,    3待出发,  4待到达,  5待服务,  6服务中,  7已完成     ,8已评价,  9拒绝中,   10已拒绝,   11无法服务)
			orderStatus: ["订单详情", "订单详情", "订单详情", "已接单", "已出发", "已到达", "服务中", "订单详情", "订单详情", "订单详情", "订单详情", "订单详情", "订单详情"], 
		},
		onShow() {
			console.log('onShow')
			if (Store.state.userInfo.id) {
				this.getLocation()
			}
		},
		onHide: function() {
			console.log('App Hide')
		},
		methods: {
			getLocation: debounceEvent(async function () {
				// let type = uni.getSystemInfoSync().platform === 'ios' ? 'wgs84' : 'gcj02'
				let type = 'gcj02'
				await uni.getLocation({
				    // type: "gcj02",
				    type,
					geocode: true,
				    success: async (res) => {
						if (res.latitude) {
							console.log(res)
							let rMap = {
								'latitude': res.latitude,
								'longitude': res.longitude
							}
							// #ifdef APP-PLUS
							if (res.address && res.address.city && res.address.district) {
								rMap.address = `${res.address.city||''}${res.address.district||''}${res.address.street||''}${res.address.streetNum||''}${res.address.poiName||''}`
							} else {
								rMap.address = ``
							}
							rMap.address = res.address
							// #endif
							
							if (type === 'wgs84') {
								const lglat = wgs84_to_gcj02(res.longitude, res.latitude)
								rMap.latitude = lglat[1]
								rMap.longitude = lglat[0]
							}
							
							if (!rMap.address) {
								// 经纬度解析地址信息
								const [err, detail] = await this.$api.getLocationAddressDetail({
									location: `${rMap.latitude},${rMap.longitude}`
								})
								if (detail.code == 10000 && detail.data.status == 0) {
									rMap.address = detail.data.result?.formatted_addresses?.recommend || detail.data.result?.address
								}
							}
							if (this.$store.state.userInfo.id) {
								this.checkCity(rMap)
								this.$store.dispatch('location', rMap)
							}
							return rMap
						}
					},
					fail: (err) =>{
						this.$store.state.fail = "定位失败"
						console.log(err);
						const system = uni.getSystemInfoSync()
						uni.showModal({ //提醒用户授权
						    title: "定位授权",  
						    content: "手机型号："+system.model+",由于无法获取到您的位置，会影响到您的正常使用，错误日志：" + JSON.stringify(err) + '   \n请将错误信息截图发送给客服以便解决',  
						    success: (res) => {  
						        if (res.confirm) {  
						            this.auth()
						        }  
						    }  
						})
						return ''
					},
				});
			}, 10000),
			async checkCity(location) {
				const [err, res] = await this.$api.checkCity({
					t_id: this.$store.state.userInfo.id,
					lat: location.latitude,
					lng: location.longitude
				})
				if (err || (res && res.code !== 10000)) return this.$toast((res || res.msg) || '获取定位城市失败')
				console.log(res)
				if(res.data.is_same !== 1 && res.data.location_supplier_id) {
					uni.showModal({
						title: "注意⚠️",
						content: `您当前定位城市在 ${res.data.location_supplier_name} \n要帮您切换到该城市接单吗？\n如果您有未完成订单请与分公司协商处理！`,
						confirmText: "确认更换",
						confirmColor: "red",
						cancelText: '不更换',
						cancelColor: '#a6a6a6',
						success: r => {
							if (r.confirm) {
								this.changeCity(res.data.location_supplier_id)
							}
						}
					})
				}
			},
			async changeCity(id){
				const [err, res] = await this.$api.confirmChangeCity({
					t_id: this.$store.state.userInfo.id,
					location_supplier_id: id,
				})
				if (err || (res && res.code !== 10000)) return this.$toast((res || res.msg) || '更换城市失败，请联系客服')
				this.$success('更换成功')
			},
			//检查版本更新
			async getVersion() {
				let that = this
				const [err, res] = await this.$api.version({
					type_limit: 22
				})
				
				if (res.code == 10000) {
					console.log(res)
					// 拿到当前版本
					plus.runtime.getProperty(plus.runtime.appid, function(inf) {
						that.versionNum = inf.version
						that.$store.commit('setVersionNum',inf.version)
						//获取系统版本  以及是否需要更新
						switch (uni.getSystemInfoSync().platform) {
							case 'android':
								if (isUpdate(inf.version, res.data[0].system_value)) {
									//是否需要更新
									that.isUpdateText = true	
									that.$store.commit('setIsUpdateText',true)
									//更新地址
									that.downloadApkUrl = res.data[4].system_value
									that.$store.commit('setDownloadApkUrl',res.data[4].system_value)
									//更新内容
									that.contentText = res.data[2].system_value
									that.$store.commit('setContent',res.data[2].system_value)
									// 当前系统
									that.clientType = 'android'
									if(res.data[3].system_value == '1'){
										// 强制更新
										uni.showModal({
											title: "版本更新",
											content: that.contentText,
											confirmText: '立即更新',
											cancelText: '退出',
											success: function(res) {
												if (res.confirm) {
													if(that.platform == 'ios'){
														//苹果
														
													}else{
													 doUpData(that.downloadApkUrl)
													}
												} else if (res.cancel) {
													that.out()
												}
											}
										})
									}else{
										uni.showModal({
											title: "版本更新",
											content: that.contentText,
											confirmText: '立即更新',
											cancelText: '稍后更新',
											success: function(res) {
												if (res.confirm) {
													const appleId = '1582447488'
													if(that.platform == 'ios'){
														//苹果
														action: `itms-apps://itunes.apple.com/cn/app/id${appleId}?mt=8`
													}else{
													 doUpData(that.downloadApkUrl)
													 }
												} 
											}
										})
									}
									// that.show()
									//隐藏tabbar
									// uni.hideTabBar();
								}
								break;
							case 'ios':
								if (isUpdate(inf.version, res.data[1].system_value)) {
									//是否需要更新
									that.isUpdateText = true
									that.clientType = 'ios'
								}
								break;
						}
			
					});
				}
			},
			
			// 授权获取定位
			async auth() {
				// #ifdef APP
				// 授权状态
				let permissionResult = '' // -1=永久拒绝， 0 = 拒绝|受限， null = 未请求
				
				// android获取定位授权
				if (permission.platform === 'android') {
				  permissionResult = await permission.requestAndroid('android.permission.ACCESS_FINE_LOCATION')
				}
				
				// ios获取定位授权
				if (permission.platform === 'ios') {
				  permissionResult = await permission.requestIOS('location')
				}
				
				// 跳转到应用的设置页面
				if (permissionResult != 1) {
				  permission.gotoAppSetting()
				}
				
				// #endif
				
			},
			
			//小程序是否为最新版本
		  checkUpdate(){
			let um = uni.getUpdateManager()
			um.onCheckForUpdate(res=>{
				console.log("新版本返回值：", res)
			  if (res.hasUpdate) {
				um.onUpdateReady(() => {
				  uni.showModal({
					content: "新版本已准备好，是否需要重启应用",
					success: res => {
					  if (res.confirm) {
						um.applyUpdate()
					  }
					}
				  })
				})
			  }
			})
		  },
		}
	}
</script>

<style lang="scss">
	@import "App.css";
	@import "uni.scss";
	
	@import '@/static/iconfont/iconfont.css';
	
	.nav-list {
		display: flex;
		flex-wrap: wrap;
		padding: 0px 40upx 0px;
		justify-content: space-between;
	}

	.nav-li {
		padding: 30upx;
		border-radius: 12upx;
		width: 45%;
		margin: 0 2.5% 40upx;
		background-image: url('https://cdn.nlark.com/yuque/0/2019/png/280374/1552996358352-assets/web-upload/cc3b1807-c684-4b83-8f80-80e5b8a6b975.png');
		background-size: cover;
		background-position: center;
		position: relative;
		z-index: 1;
	}

	.nav-li::after {
		content: "";
		position: absolute;
		z-index: -1;
		background-color: inherit;
		width: 100%;
		height: 100%;
		left: 0;
		bottom: -10%;
		border-radius: 10upx;
		opacity: 0.2;
		transform: scale(0.9, 0.9);
	}

	.nav-li.cur {
		color: #fff;
		background: rgb(94, 185, 94);
		box-shadow: 4upx 4upx 6upx rgba(94, 185, 94, 0.4);
	}

	.nav-title {
		font-size: 32upx;
		font-weight: 300;
	}

	.nav-title::first-letter {
		font-size: 40upx;
		margin-right: 4upx;
	}

	.nav-name {
		font-size: 28upx;
		text-transform: Capitalize;
		margin-top: 20upx;
		position: relative;
	}

	.nav-name::before {
		content: "";
		position: absolute;
		display: block;
		width: 40upx;
		height: 6upx;
		background: #fff;
		bottom: 0;
		right: 0;
		opacity: 0.5;
	}

	.nav-name::after {
		content: "";
		position: absolute;
		display: block;
		width: 100upx;
		height: 1px;
		background: #fff;
		bottom: 0;
		right: 40upx;
		opacity: 0.3;
	}

	.nav-name::first-letter {
		font-weight: bold;
		font-size: 36upx;
		margin-right: 1px;
	}

	.nav-li text {
		position: absolute;
		right: 30upx;
		top: 30upx;
		font-size: 52upx;
		width: 60upx;
		height: 60upx;
		text-align: center;
		line-height: 60upx;
	}

	.text-light {
		font-weight: 300;
	}

	@keyframes show {
		0% {
			transform: translateY(-50px);
		}

		60% {
			transform: translateY(40upx);
		}

		100% {
			transform: translateY(0px);
		}
	}

	@-webkit-keyframes show {
		0% {
			transform: translateY(-50px);
		}

		60% {
			transform: translateY(40upx);
		}

		100% {
			transform: translateY(0px);
		}
	}
</style>
